var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterChatOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Selected=False, Name=Chat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5113 6C52.7923 6 65.9907 19.4315 65.9907 36C65.9907 52.5685 52.7923 66 36.5113 66C30.0618 66 24.096 63.8923 19.2428 60.3168L9.70608 63.9567C8.29639 64.4947 6.71751 63.788 6.17955 62.3783C5.95624 61.7932 5.94077 61.149 6.13573 60.5538L9.92499 48.9771C8.07065 45.0499 7.03179 40.6484 7.03179 36C7.03179 19.4315 20.2302 6 36.5113 6ZM36.5113 12C23.5676 12 13.0318 22.7219 13.0318 36C13.0318 39.2971 13.6796 42.4899 14.9165 45.4408L15.3506 46.4152L16.37 48.5743L13.9691 55.908L20.164 53.543L22.8016 55.4862C26.7674 58.4079 31.5154 60 36.5113 60C49.4549 60 59.9907 49.2781 59.9907 36C59.9907 22.7219 49.4549 12 36.5113 12ZM30 36.75C30 34.6789 28.3211 33 26.25 33C24.1789 33 22.5 34.6789 22.5 36.75C22.5 38.8211 24.1789 40.5 26.25 40.5C28.3211 40.5 30 38.8211 30 36.75ZM36.75 33C38.8211 33 40.5 34.6789 40.5 36.75C40.5 38.8211 38.8211 40.5 36.75 40.5C34.6789 40.5 33 38.8211 33 36.75C33 34.6789 34.6789 33 36.75 33ZM51 36.75C51 34.6789 49.3211 33 47.25 33C45.1789 33 43.5 34.6789 43.5 36.75C43.5 38.8211 45.1789 40.5 47.25 40.5C49.3211 40.5 51 38.8211 51 36.75Z",
    fill: "#9B9DA0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterChatOff);
export default __webpack_public_path__ + "static/media/footer-chat-off.5d87b5d50739b7f152d2ab0d249d64fd.svg";
export { ForwardRef as ReactComponent };